<script>
  export let child
</script>
<svelte:component this={child.component} {...child.props} />
